import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import LatestGrid from "./components/LatestGrid";
import NewsPreview from "./components/NewsPreview";
import PlatformIntro from "./components/PlatformIntro";
import SearchBar from "@/components/feature/SearchBar";
import { useSeo } from "@/hooks/useSeo";
import { getFeaturedMedia } from "@/lib/data";

export default function Home() {
  const featured = getFeaturedMedia();

  useSeo(
    "榴莲视频-最新影视资源在线观看及影视资讯平台",
    "榴莲视频提供丰富的影视内容，包括电影、电视剧和综艺节目，用户可以浏览最新影视资讯，发现热门影视作品，体验优质在线视频服务。",
    "榴莲视频,影视,电影,电视剧,在线观看,影视资讯,在线视频,视频平台",
  );

  return (
    <>
      <HeroCarousel items={featured} />

      <section className="border-y border-background-200/60 bg-background-100/40">
        <div className="mx-auto flex max-w-[1280px] flex-col items-center gap-3 px-4 py-6 md:px-8 md:py-7">
          <p className="text-sm text-foreground-400">
            <i className="ri-search-eye-line mr-1 text-accent-500"></i>
            想看点什么？搜索影视作品或资讯
          </p>
          <div className="w-full max-w-2xl">
            <SearchBar variant="hero" />
          </div>
          <div className="flex flex-wrap justify-center gap-2 text-xs text-foreground-300">
            <span>热门搜索：</span>
            {["星际回响", "长安夜行", "科幻", "悬疑", "综艺"].map((k) => (
              <span key={k} className="rounded-full bg-background-200/70 px-2.5 py-0.5 text-foreground-400">
                {k}
              </span>
            ))}
          </div>
        </div>
      </section>

      <CategoryEntries />
      <LatestGrid />
      <NewsPreview />
      <PlatformIntro />
    </>
  );
}